module.exports = __webpack_public_path__ + "static/media/be-best.948da2fa.jpg";